<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" @close="onClose" width="1200px">
    <template slot="title">
      <h2 style="margin: 2px 0">
        {{ dialogTitle }}
        <span
            style="display: inline-block;cursor: pointer;margin-left: 30px;font-size: 14px;color: #8a8e99;line-height: 30px"
            @click="handleRefresh('month')"
            title="数据更新" class="el-icon-refresh"></span>
      </h2>
    </template>
    <div>
      <el-form :model="reqParams" inline size="mini" v-if="!isSale">
        <el-form-item label="销售">
          <el-select v-model="reqParams.sale_id" @change="handleQuery" clearable>
            <el-option :value="option.sale_id" :label="option.sale" v-for="(option,key) in options" :key="key">
              <span>{{ option.sale || '' }}</span>
              <span style="float: right;font-weight: lighter" title="单量">{{ option.count || 0 }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click.stop.native="handleQuery" :disabled="loadingStatus" :loading="loadingStatus">
            搜索
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loadingStatus" element-loading-text="加载中……"
           element-loading-spinner="el-icon-loading">
        <el-table ref="apeTable"
                  class="table"
                  :data="dataList"
                  :loading="loadingStatus"
                  :pagingData="pagingData"
                  :is-full-height="true"
                  show-summary
                  :summary-method="getSummaries"
                  @sort-change="getList"
                  highlight-current-row
                  border>
          <el-table-column
              type="index"
              label="序号"
              header-align="center"
              width="55">
          </el-table-column>
          <el-table-column align="center" label="订单编号" prop="order_no">
            <template slot-scope="{row}">
              <to-order-detail :order="row" :is-pre-executor="1"/>
            </template>
          </el-table-column>
          <el-table-column align="center" label="客户名称" prop="customer_name"></el-table-column>
          <el-table-column align="center" label="品牌" prop="brand" show-overflow-tooltip></el-table-column>
          <el-table-column align="center" label="产品/内容" prop="product"></el-table-column>
          <el-table-column align="center" label="合作形式" prop="form_of_cooperation"></el-table-column>
          <el-table-column align="center" label="红人昵称" prop="artist_name"></el-table-column>
          <el-table-column align="center" label="销售" prop="sale" sortable="custom"></el-table-column>
          <el-table-column align="center" label="执行" prop="executor"></el-table-column>
          <el-table-column align="center" label="含税收入" prop="payment_account">
            <template slot-scope="{row}">
              {{ Number(row.payment_account).toFixed(2) || 0 }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="bottom_row">
        <div class="tips"> 关联客户的订单（排除全案系的主单，即 <b>A开头订单</b> 并且 <b>未撤单</b>）
        </div>

        <Pagination :total="pagingData.total" :limit.sync="pagingData.page_size"
                    :hidden='pagingData.total===0' :page.sync="pagingData.current_page"
                    @pagination="getList"></Pagination>
        <!--        <el-pagination-->
        <!--            class="pagination"-->
        <!--            @size-change="getList"-->
        <!--            @current-change="getList"-->
        <!--            :current-page="pagingData.current_page"-->
        <!--            :page-size="pagingData.page_size"-->
        <!--            :layout="pagingData.layout"-->
        <!--            :total="pagingData.total"-->
        <!--            style="display: block"-->
        <!--            background>-->
        <!--        </el-pagination>-->

      </div>
    </div>

  </el-dialog>
</template>

<script>
import {
  addProfileCustomer,
  adProfileCustomerList,
  myAdProfileCustomerList,
  saleProfileCustomerOption
} from "@/api/profileCustomer";
import ToOrderDetail from "@/views/adOrder/components/ToDetail.vue";

export default {
  name: "infoDetailModal",
  components: {ToOrderDetail},
  props: {
    isSale: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
  },
  data() {
    return {
      dataList: [],
      loadingStatus: false,
      // 分页信息
      pagingData: {
        total: 0,
        page_size: 20,
        current_page: 1,
        orderBy: null
        // offset: 0
      },
      dialogTitle: null,
      updateDate: null,
      reqParams: {
        id: null,
        year_month: null,
        sale: null,
        sale_id: null,
        orderBy: null
      },
      options: []
    }
  },
  methods: {
    onOpen() {
      this.$emit('opened')
    },
    onClose() {
      this.$emit('success')
    },
    init(searchCondition) {
      this.dialogTitle = `${searchCondition.title} (${searchCondition.year_month})`
      // console.log(searchCondition)
      this.reqParams.year_month = searchCondition.year_month
      this.reqParams.id = searchCondition.id
      if (!this.isSale)
        this.loadOptions()

      this.handleQuery()
    },
    changeTableSort({prop, order}) {
      this.reqParams.orderBy = `\`${prop}\` ${order === 'descending' ? 'desc' : 'asc'}`
      this.getList()
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.reqParams).forEach((key) => {
        if (this.reqParams[key]) {
          condition[key] = this.reqParams[key]
        }
      })
      if (this.isSale) {
        //销售页面：
        condition['sale_id'] = this.user.id
      }

      return condition
    },
    async loadOptions() {
      let searchCondition = this.handleSearchCondition();
      const {data} = await saleProfileCustomerOption(searchCondition)
      this.options = data
    },
    handleQuery() {
      this.pagingData.current_page = 1
      this.getList()
    },
    async getList() {
      this.loadingStatus = true
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, {
        page_size: this.pagingData.page_size,
        current_page: this.pagingData.current_page
      })

      if (this.isSale) {
        //查销售自己的
        let {data} = await myAdProfileCustomerList(searchCondition)
        this.$nextTick(() => {
          this.dataList = data.list || []
          this.pagingData = data.pages
        })
      } else {
        let {data} = await adProfileCustomerList(searchCondition)
        this.$nextTick(() => {
          this.dataList = data.list || []
          this.pagingData = data.pages
        })
      }

      setTimeout(() => {
        this.loadingStatus = false
      }, 100)
    },

    async onSubmit() {
      //新建
      const {data: {id}} = await addProfileCustomer(this.formData)
      if (id) {
        this.$message.success('新建成功！')
        this.$emit('success')
      }
    },
    handleRefresh() {
      this.loadingStatus = true
      this.$emit('refresh')
    },
    getSummaries(param) {
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '合计'
          return
        }

        if (['payment_account'].indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          switch (column.property) {
            case "payment_account":
              sums[index] = '￥' + this.gFunc.numberFormat(sums[index], 2);
              break;
          }
        }
      });
      return sums
    }
  }
  ,
}
</script>
<style lang="scss" scoped>
.bottom_row {
  width: 100%;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .tips {
    line-height: 40px;
    color: #8a8e99;
  }
}

</style>
